import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pre-trial',
  templateUrl: './pre-trial.component.html'
})
export class PreTrialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./client/app/pre-trial/pre-trial.component.ts